import { EvmAddressSummaryInfo, type EvmTokenSummaryInfo } from '~/api/repository'
import ADT = EvmAddressSummaryInfo.ADT;
import { IMAGE_BASE_URL } from '~/constants/image.constant'
import { type ICommonSummaryInfo } from '~/types/common.type'
import { type ITokenType } from '~/types/token-type.type'

export class CommonSummaryModel {
  protected readonly name: string
  protected readonly address: string
  protected readonly symbol: string

  constructor(data: ICommonSummaryInfo) {
    this.name = data.name
    this.address = data.address
    this.symbol = data.symbol
  }
}

export class AddressSummaryModel extends CommonSummaryModel {
  readonly addressType: ADT

  constructor(data: EvmAddressSummaryInfo) {
    super({
      name: data.NN,
      address: data.ADDR,
      symbol: data.SB
    })
    this.addressType = data.ADT
  }

}

export class TokenSummaryModel extends CommonSummaryModel {
  readonly image: string

  constructor(data: EvmTokenSummaryInfo, tokenType?: tokenType) {
    super({
      name: data.NN || tokenType || 'N/A',
      address: data.ADDR,
      symbol: data.SB
    })
    this.image = data.IMG || IMAGE_BASE_URL + '/token/default.png'
  }
}import { LandingPageInfo } from '@/api/repository'

export interface LandingPageInfoModel {
  id: string
  title: string
  start: string
  end: string
  type: LandingPageInfo.CTYPE
  url: string[]
  headCopy: string
  subCopy: string
  noticeText: string
  isAllMaintenance: boolean
}

export const createLandingPageInfoModel = (resDto: LandingPageInfo | null): LandingPageInfoModel | null => {
  if (resDto === null) {
    return null
  }

  return {
    id: resDto.ID,
    title: resDto.TITLE,
    start: resDto.EXPST,
    end: resDto.EXPEND,
    type: resDto.CTYPE,
    url: resDto.CURL,
    headCopy: resDto.HCPY,
    subCopy: resDto.SCPY,
    noticeText: resDto.NTTXT,
    isAllMaintenance: resDto.CTYPE === LandingPageInfo.CTYPE.ALL,
  }
}
